import { InjectionToken } from '@angular/core';
import { BmEnvironments } from './interfaces';

const API_ENDPOINT = new InjectionToken<BmEnvironments>('Api endpoint');
const CACHE_VALIDATION_TIME = new InjectionToken<number>('Cache validation time');

export {
  API_ENDPOINT,
  CACHE_VALIDATION_TIME,
};
